import { RestService } from "@sinossi/mates-react-library"
import {
    CreateVisitRequest,
    GenericCreationResponse,
    PaginatedResponse,
    UpdateVisitRequest,
    Visit,
    VisitFilter
} from "models"

export class VisitService {

    /**
     * Get visit details by ID
     */
    static getVisit = (visitId: string, callback: any, catchCallback: any) => {
        RestService
            .get<Visit>(`/api/visit/${visitId}`)
            .then(callback)
            .catch(catchCallback)
    }

    /**
     * Get visits by asset ID
     */
    static getVisitsByAsset = (assetId: string, callback: any, catchCallback: any) => {
        RestService
            .get<PaginatedResponse<Visit>>(`/api/visit/asset/${assetId}`)
            .then(callback)
            .catch(catchCallback)
    }

    /**
     * Filter visits
     */
    static filterVisits = (filter: VisitFilter, callback: any, catchCallback: any) => {
        RestService
            .post<PaginatedResponse<Visit>>("/api/visit/filter", filter)
            .then(callback)
            .catch(catchCallback)
    }

    /**
     * Create a new visit
     */
    static createVisit = (request: CreateVisitRequest): Promise<GenericCreationResponse<string>> => {
        return RestService.post<GenericCreationResponse<string>>("/api/visit", request)
    }

    /**
     * Update an existing visit
     */
    static updateVisit = (visitId: string, request: UpdateVisitRequest, callback: any, catchCallback: any) => {
        RestService
            .put(`/api/visit/${visitId}`, request)
            .then(callback)
            .catch(catchCallback)
    }

    /**
     * Delete a visit
     */
    static deleteVisit = (visitId: string, callback: any, catchCallback: any) => {
        RestService
            .delete(`/api/visit/${visitId}`)
            .then(callback)
            .catch(catchCallback)
    }
}
